export const featuredPortfolio = [
    {
        id: 1,
        title: "KickAbout",
        img: "assets/ka1.png",
        alt: "A full webapp where users could create an account to see/arrange football matches in their local area and interract with players from games they have previously taken part in. Uses Ruby on Rails with Google Location and Google Maps APIs and SASS for the front-end"
    },
    {
        id: 2,
        title: "Portfolio",
        img: "assets/portfolio.png",
        alt: "This site! It has been built using JavaScript and React and makes use of NPM's Simple React Lightbox"
    },
    {
        id: 3,
        title: "AceBook",
        img: "assets/acebook.png",
        alt: "A social media site created using Ruby on Rails with a PostgreSQL database. Users can post text or pictures, like/unlike or comment on posts"
    },
    {
        id: 4,
        title: "Filter",
        img: "assets/sepia.png",
        alt: "An app created using C as part of Harvard University's CS50x course. It takes in a JPEG image and can apply image filters such as Grayscale, Sepia or Blur and output the adjusted image"
    }
];

export const rubyPortfolio = [
    {
        id: 1,
        title: "KickAbout",
        img: "assets/ka1.png",
        alt: "A full webapp where users could create an account to see/arrange football matches in their local area and interract with players from games they have previously taken part in. Uses Ruby on Rails with Google Location and Google Maps APIs and SASS for the front-end"
    },
    {
        id: 2,
        title: "AceBook",
        img: "assets/acebook.png",
        alt: "A social media site created using Ruby on Rails with a PostgreSQL database. Users can post text or pictures, like/unlike or comment on posts"
    },
    {
        id: 3,
        title: "MakersBnB",
        img: "assets/makersbnb.png",
        alt: "An accommodation booking site built using Ruby and CSS with a PostgreSQL database. Users are able to list available acommodation and then approve or reject requests placed by other users"
    }
];

export const reactPortfolio = [
    {
        id: 1,
        title: "Portfolio",
        img: "assets/portfolio.png",
        alt: "This site! It has been built using JavaScript and React and makes use of NPM's Simple React Lightbox"
    }
];

export const jsPortfolio = [
    {
        id: 1,
        title: "Portfolio",
        img: "assets/portfolio.png",
        alt: "This site! It has been built using JavaScript and React and makes use of NPM's Simple React Lightbox"
    },
    {
        id: 2,
        title: "Bowling Challenge",
        img: "assets/bowling.png",
        alt: "A bowling scorecard built while I was learning how to use Javascript, features a simple interfface that makes adjustments based on strikes/half-strikes that are inputted correctly"
    },
    {
        id: 3,
        title: "Thermostat",
        img: "assets/therm.png",
        alt: "A simple thermostat app that uses an API to pull current temeratures from a number of world cities"
    },
    {
        id: 4,
        title: "NotesJS",
        img: "assets/notejs.png",
        alt: "A one-page app that uses local storage to save simple text notes for a user"
    }
];

export const otherPortfolio = [
    {
        id: 1,
        title: "Filter",
        img: "assets/sepia.png",
        alt: "An app created using C as part of Harvard University's CS50x course. It takes in a JPEG image and can apply image filters such as Grayscale, Sepia or Blur and output the adjusted image"
    }
];